import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '../../services/shared-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadImageModalComponent } from '../upload-image-modal/upload-image-modal.component';
import { navigationLinksMap, roleMap, NavigationLink } from './navigation-links';
import { CpSigningUrlsService } from 'src/app/services/cp-signing-urls.service';
import { CpRolesEnum, MODAL_OPTIONS } from '../global-meta-data';
import { doesCorporateUserContainRole } from 'appRootPath/utils-role-check';
import { environment } from 'src/environments/environment';

const isAuctionEnabledForEnv = environment.isAuctionEnabled;

@Component({
  selector: 'app-side-nav-bar',
  templateUrl: './side-nav-bar.component.html',
  styleUrls: ['./side-nav-bar.component.scss']
})
export class SideNavBarComponent implements OnInit {

  sidebarState = true;
  linksToShow: NavigationLink[] = [];
  isIssuer = false;
  isIpa = false;
  isInvestor = false;
  isAdmin = false;
  isInvestorOnlyAdmin = false;
  isListingShown = false;
  signingurls;

  constructor(
    private sharedData: SharedDataService,
    private modalService: NgbModal,
    private signingService: CpSigningUrlsService
  ) {
  }


/**
 * Angular On Init hook
 * adds test signing urls to side panel
 * sets links to show on the sidepanel
 */
  ngOnInit() {
    // TODO: Signing URLs for testing should only be shown when the environment is not production.
    this.addSigningUrlsObservable();
    this.setSideNavLinks();
  }

  /**
   * Based on the user roles, sets the appropriate side nav links.
   */
  setSideNavLinks() {
    const currentUserData = this.sharedData.getUserDataFromLS();
    const role = currentUserData ? roleMap[currentUserData.roleType] : null;
    const isAuctionUser = isAuctionEnabledForEnv && this.sharedData.getUserSelectionFromLS().is_auction_user;

    this.isIssuer = Boolean(role === 'issuer');
    this.isIpa = Boolean(role === 'ipa');
    this.isInvestor = Boolean(role === 'investor');
    this.isAdmin = currentUserData && currentUserData.isCorporateAdmin;
    if (role) {
      this.linksToShow = isAuctionUser ?
        navigationLinksMap[role] :
        navigationLinksMap[role].filter(link => !link.is_auction_link);
    }
    if (this.isAdmin) {
      this.linksToShow = this.setAdminPortalLinks(currentUserData);
    }
  }

  /**
   * Sets the Admin Portal navigation links based on the corporate user roles.
   * @param userData - Details of the logged in user.
   */
  setAdminPortalLinks(userData) {
    const hasIssuerRole = doesCorporateUserContainRole(userData, CpRolesEnum.ISSUER);
    const hasInvestorRole = doesCorporateUserContainRole(userData, CpRolesEnum.INVESTOR);
    const hasIpaRole = doesCorporateUserContainRole(userData, CpRolesEnum.IPA);

    if (hasInvestorRole && !hasIpaRole && !hasIssuerRole) {
      // Sets the value of isInvestorOnlyAdmin flag
      this.setIsInvestorOnlyAdminValue(hasInvestorRole && !hasIpaRole && !hasIssuerRole);

      return navigationLinksMap['onboarding_investor'];
    }

    return navigationLinksMap['onboarding'];
  }

  /**
   * Sets the value of flag isInvestorOnlyAdmin.
   * @param stateValue - Value to set.
   */
  setIsInvestorOnlyAdminValue(stateValue) {
    this.isInvestorOnlyAdmin = stateValue;
  }

  /**
   * Adds Observable logic for signing urls.
   */
  addSigningUrlsObservable() {
    this.signingService.signingUrlsObservable.subscribe(urls => {
      this.signingurls = urls;
    });
  }

  /**
   * Opens Upload Letter head modal.
   */
  uploadLetterhead() {
    const modalRef = this.modalService.open(UploadImageModalComponent, MODAL_OPTIONS);
  }

  /**
   * Sets the given visibility state value to the Market Listings side panel state.
   * @param sidebarState - Visibility State of the Market Listings.
   */
  setSidebarState(sidebarState) {
    this.isListingShown = sidebarState;
  }

  /**
   * Show the market listings side panel.
   */
  showMarketListings() {
    this.isListingShown = true;
  }

}
